var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextareaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.311523,
    width: 40,
    height: 32,
    rx: 4,
    fill: "#C6FB55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_9198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0615 11.125H28.5615C28.7604 11.125 28.9512 11.046 29.0919 10.9053C29.2325 10.7647 29.3115 10.5739 29.3115 10.375C29.3115 10.1761 29.2325 9.98532 29.0919 9.84467C28.9512 9.70402 28.7604 9.625 28.5615 9.625H12.0615C11.8626 9.625 11.6718 9.70402 11.5312 9.84467C11.3905 9.98532 11.3115 10.1761 11.3115 10.375C11.3115 10.5739 11.3905 10.7647 11.5312 10.9053C11.6718 11.046 11.8626 11.125 12.0615 11.125Z",
    fill: "#141046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0615 14.875H24.0615C24.2604 14.875 24.4512 14.796 24.5919 14.6553C24.7325 14.5147 24.8115 14.3239 24.8115 14.125C24.8115 13.9261 24.7325 13.7353 24.5919 13.5947C24.4512 13.454 24.2604 13.375 24.0615 13.375H12.0615C11.8626 13.375 11.6718 13.454 11.5312 13.5947C11.3905 13.7353 11.3115 13.9261 11.3115 14.125C11.3115 14.3239 11.3905 14.5147 11.5312 14.6553C11.6718 14.796 11.8626 14.875 12.0615 14.875Z",
    fill: "#141046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5615 17.125H12.0615C11.8626 17.125 11.6718 17.204 11.5312 17.3447C11.3905 17.4853 11.3115 17.6761 11.3115 17.875C11.3115 18.0739 11.3905 18.2647 11.5312 18.4053C11.6718 18.546 11.8626 18.625 12.0615 18.625H28.5615C28.7604 18.625 28.9512 18.546 29.0919 18.4053C29.2325 18.2647 29.3115 18.0739 29.3115 17.875C29.3115 17.6761 29.2325 17.4853 29.0919 17.3447C28.9512 17.204 28.7604 17.125 28.5615 17.125Z",
    fill: "#141046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0615 20.875H12.0615C11.8626 20.875 11.6718 20.954 11.5312 21.0947C11.3905 21.2353 11.3115 21.4261 11.3115 21.625C11.3115 21.8239 11.3905 22.0147 11.5312 22.1553C11.6718 22.296 11.8626 22.375 12.0615 22.375H24.0615C24.2604 22.375 24.4512 22.296 24.5919 22.1553C24.7325 22.0147 24.8115 21.8239 24.8115 21.625C24.8115 21.4261 24.7325 21.2353 24.5919 21.0947C24.4512 20.954 24.2604 20.875 24.0615 20.875Z",
    fill: "#141046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_9198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.31152 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextareaIcon);
export default __webpack_public_path__ + "static/media/textarea-icon.55311ff23c3b1e358daa296ece50583f.svg";
export { ForwardRef as ReactComponent };